const messages = {
  title: "Velkommen Bridgestone <span class='text-danger'>PLUS</span>",
  termsAndConditions: "Vilkår og betingelser",
  accept: "Godta",
  decline: "Avslå",
  dataModal:
    "For å tilpasse dette tilbudet til dine interesser, ber vi deg kort angi dine produktinteresser eller forretningsområder.",
  scrollToAccept: "Rull ned for å godta våre vilkår for å fortsette",
  welcomeMessage: "Velkommen til Bridgestone Plus",
  tailorOffer:
    "For å tilpasse dette tilbudet til dine interesser, ber vi deg kort angi dine produktinteresser eller forretningsområder.",
  bussinessType:
    "For å tilpasse dette tilbudet til dine interesser, ber vi deg kort angi dine produktinteresser eller forretningsområder.",
  selectAreas: "Vennlegst velg fra følgende områder",
  multipleAnswers: "(fleire svar er mulige):",
  personalPreferences: "Personlige preferanser",
  carTyres: "Dekk til biler, SUV-er, varebiler",
  motorcyclesTyres: "Dekk til motorsykler",
  truckBusTyres: "Dekk til lastebiler og busser",
  agricultureTyres: "Dekk til landbrukskjøretøy",
  otrTyres: "OTR-dekk",
  save: "Lagra",
  businessRelationship: "Hva er din forretningsrelasjon med Bridgestone?",
  selectRelationship: "Vennlegst velg*:",
  tradingPartner: "Jeg er en handelspartner som...",
  tradingPartnerDirect: "... bestiller direkte fra Bridgestone",
  tradingPartnerIndirect: "... bestiller indirekte (via grossister osv.)",
  tradingPartnerBoth: "... bestiller både direkte og indirekte",
  fleetResponsibleDirect: "Jeg er flåteansvarlig som...",
  fleetResponsibleIndirect: "... bestiller indirekte (via handel eller grossist)",
  fleetResponsibleBoth: "... bestiller både direkte og indirekte",
  noBusinessRelationship:
    "<b>Jeg har ingen forretningsrelasjon med Bridgestone</b> (verken direkte eller indirekte)",
  yourCustomerNumber: "Ditt Bridgestone kundenummer*:",
  enterCustomerNumber: "Skriv inn kundenummeret ditt",
  waitPersonalisedView:
    "Vennlegst vent et øyeblikk, din personlige visning av BRIDGESTONE PLUS genereres.",
  personalised: "PERSONLIG",
  plusInfo:
    "Her finner du informasjon om Plus-kontoen din og Plus-innboksen din.",
  continue: "Fortsett",
  skip: "Hopp over",
  oneOfTwo: "1 av 2",
  openApps:
    "Du kan åpne appene du allerede er registrert for direkte. Du kan også be om tilgang til andre apper som kan være relevante for deg.",
  requiredFields:
    "Vennlegst fyll ut de obligatoriske feltene: Tittel, Fornavn, Etternavn",
  stage: "Steg",
  chooseOne: "(Vennlegst kryss av minst 1 boks)",
  required: "*obligatoriske felt",
  lengthCsNumber: "Kundenummerlengde: 6–10 sifre",
  waitForAdminApproval:
    "Takk for at du meldte deg på Bridgestone Plus-belønningsprogrammet. Vi vurderer søknaden din. Du vil motta en bekreftelse på e-post når søknaden din er godkjent.",
  selectTyres: "AKTIVITETSSEKTOR OG PROFIL",
};

export default {
  messages,
};
